import {Component} from '@angular/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
}



// WEBPACK FOOTER //
// /media/webdesign/5E0ECC7B0ECC4E29/www/leasytool/src/app/not-found/not-found.component.ts